import React from 'react';
import loader from '../../../assets/loader.png'

export default function Loader(){
    return(
        <div className='loaderContainer'>
            <img className='loader' src={loader}/>
        </div>
    )
}